import React from 'react';
import { Portal } from 'react-portal';
import styled from 'styled-components';

export function FullScreenLoader({message, visible}) {
    return (
        <Portal>
            <Wrapper visible={visible}>
                {visible &&
                    <div className="message-wrapper">
                        <div className="logo-wrapper">
                            <img src="/wp-content/themes/nojesresor/static/images/nojesresor-logo.svg" />
                        </div>
                        <div className="message">
                            {message}
                        </div>
                    </div>
                }
            </Wrapper>
        </Portal>
    );
}

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9000;
    background: rgba(0, 0, 0, 0.8);
    transition: all 0.3s;
    visibility: ${({visible}) => visible ? 'visible' : 'hidden'};
    opacity: ${({visible}) => visible ? 1 : 0};

    .message-wrapper {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .logo-wrapper {
        text-align: center;
    }

    .message {
        margin: 15px 0 0 0;
        color: white;
        font-family: "adelle", serif;
        white-space: nowrap;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
        position: relative;

        @media (max-width: 1170px) {
            width: 80vw;
            white-space: normal;
            animation: textOpacity 4s ease infinite;
        }

        @media (min-width: 1170px) {
            font-size: 28px;
            animation: textSlide 4s ease infinite, textOpacity 4s ease infinite;
        }

        @media screen and (max-width: 1920px) and (min-width: 1024px) {
            font-size: 14px;
        }
    }
`;
